import { render, staticRenderFns } from "./ContactInfoComponent.vue?vue&type=template&id=6dd60579&scoped=true&"
import script from "./ContactInfoComponent.vue?vue&type=script&lang=js&"
export * from "./ContactInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoComponent.vue?vue&type=style&index=0&id=6dd60579&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd60579",
  null
  
)

export default component.exports